<script>
import { BFormGroup } from "bootstrap-vue";

export default {
  mixins: [BFormGroup],
  beforeUpdate() {
    this.makeLabelSlot(this.label);
  },
  methods: {
    makeLabelSlot(label) {
      if (!this.label) {
        return;
      }
      const labelElement = this.$createElement("EHQFieldLabel", {
        props: {
          label: label,
        },
      });
      this.$slots.label = [labelElement];
    },
  },
  render: BFormGroup.render,
};
</script>
